import React from "react";
import { Landmark } from "lucide-react";
import { ResultDigits } from "./ResultDigits";
import { keralaOfficial, isOfficialKerala } from "../lib/kerala";
import { dateLabel, to12h } from "../lib/format";

const istYmd = (offsetDays = 0) => new Date(Date.now() + 5.5 * 3600000 - offsetDays * 86400000).toISOString().slice(0, 10);

/* Kerala-only view: today + yesterday per Kerala show, with the official lottery name under the number */
export function KeralaPanel({ games, results, lang }) {
  const ta = lang === "ta";
  const kerala = games.filter((g) => g.category === "Kerala" && g.mode !== "interval").sort((a, b) => (a.draw_time || "").localeCompare(b.draw_time || ""));
  if (!kerala.length) return null;
  const days = [[istYmd(0), ta ? "இன்று" : "Today"], [istYmd(1), ta ? "நேற்று" : "Yesterday"]];
  return (
    <div className="rl-card overflow-hidden" data-testid="kerala-panel">
      <div className="px-3.5 py-2.5 text-white flex items-center gap-2" style={{ background: "linear-gradient(120deg,#064e3b,#0f172a)" }}>
        <Landmark className="w-4 h-4 text-amber-300" />
        <div className="min-w-0">
          <div className="font-display font-bold text-sm">{ta ? "கேரளா results" : "Kerala results"}</div>
          <div className="text-[10px] text-emerald-200">{ta ? "அரசு 3 PM லாட்டரி + Kerala Evening" : "Official 3 PM lottery + Kerala Evening"}</div>
        </div>
      </div>
      <div className="divide-y divide-slate-100">
        {days.map(([ymd, label]) => (
          <div key={ymd} className="px-3.5 py-2.5" data-testid={`kerala-day-${label.toLowerCase()}`}>
            <div className="flex items-center gap-2 mb-1.5">
              <span className={`text-[10px] font-black tracking-widest rounded-full px-2.5 py-0.5 ${ymd === istYmd(0) ? "bg-amber-100 text-amber-800" : "bg-slate-200 text-slate-600"}`}>{label}</span>
              <span className="text-[10px] text-slate-400">{dateLabel(ymd)}</span>
            </div>
            <div className="space-y-1.5">
              {kerala.map((g) => {
                const r = results.find((x) => x.game_id === g.id && x.draw_date === ymd);
                const ko = isOfficialKerala(g) ? keralaOfficial(ymd) : null;
                return (
                  <div key={g.id} className="flex items-center justify-between gap-2" data-testid={`kerala-row-${g.id}-${ymd}`}>
                    <div className="min-w-0 flex-1">
                      <div className="text-sm font-bold text-slate-900 truncate">{g.name} <span className="text-[10px] font-semibold text-slate-500">{to12h(g.draw_time)}</span></div>
                      {ko && <div className="text-[10px] text-emerald-800 font-semibold truncate" data-testid={`kerala-official-${g.id}-${ymd}`}>🏛️ {ko.label} · {ko.weekday}</div>}
                    </div>
                    {r ? <ResultDigits number={r.winning_number} size="w-8 h-8 text-sm" className="shrink-0" testId={`kerala-digits-${g.id}-${ymd}`} />
                      : <span className="text-[11px] font-bold text-slate-400 shrink-0" data-testid={`kerala-pending-${g.id}-${ymd}`}>{ymd === istYmd(0) ? (ta ? `${to12h(g.draw_time)}-க்கு result` : `Result at ${to12h(g.draw_time)}`) : (ta ? "இல்லை" : "No draw")}</span>}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
